/* Dependencies */
import isWithinInterval from "date-fns/isWithinInterval";

export const EPG = {
  MAX_SCHEDULES_PER_REQUEST: 100,
  MINUTES_TO_LOAD: 180,
  STATIONS_TO_LOAD: 15
};

export const CHANNEL_LOGO_WIDTH = 25;

export const EPG_FILTERS = {
  DEFAULT: 6, // For you
  MOST_WATCHED: 7
};

export const isLive = (currentTime, start, end) => isWithinInterval(currentTime, { start, end });
